import React, { FC, useState, useEffect } from "react";
import { createUseStyles } from "react-jss";

import ClickOutsideListener from "HOC/ClickOutsideListener";
import Toast from "Components/Toast";

import Share from "Assets/images/share.svg";
import ChainLink from "Assets/images/chainlink.svg";
import Twitter from "Assets/images/twitter_x.svg";
import Pintinterest from "Assets/images/pintinterest.svg";
import Facebook from "Assets/images/facebook.svg";
import useClipboard from "react-use-clipboard";
import styles from "./styles";

interface Props {
  copyURL: () => void;
  tinyURL: string;
  className?: string;
  url?: string;
  svgColor?: string;
  backgroundColor?: string;
  id: number;
}

const ShareMenu: FC<Props> = (props: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    copyURL,
    url,
    className,
    tinyURL,
    id,
    svgColor,
    backgroundColor,
  } = props;
  const useStyles = createUseStyles(styles);
  const classes = useStyles({
    svgColor,
    backgroundColor,
  });
  const [showMenu, setShowMenu] = useState(false);
  const [, setCopied] = useClipboard(tinyURL);

  useEffect(() => {
    if (tinyURL) {
      setCopied();
    }
  }, [setCopied, tinyURL]);

  const onOpenMenu = () => {
    setShowMenu(!showMenu);
  };
  const onMenuItemLink = () => {
    setShowMenu(!showMenu);
    copyURL();
  };

  const onMenuItemTwitter = () => {
    setShowMenu(!showMenu);
    window.open(
      `https://www.twitter.com/share?url=${encodeURIComponent(url)}`,
      "_blank",
      "noopener"
    );
  };

  const onMenuItemPintInterest = () => {
    setShowMenu(!showMenu);
    window.open(
      `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}`,
      "_blank",
      "noopener"
    );
  };

  const onMenuItemFacebook = () => {
    setShowMenu(!showMenu);
    window.open(
      `https://www.facebook.com/share.php?u=${encodeURIComponent(url)}`,
      "_blank",
      "noopener"
    );
  };

  const clickOutside = () => {
    setShowMenu(false);
  };

  return (
    <>
      <ClickOutsideListener clickOutside={clickOutside}>
        <div data-testid="sharemenu" tabIndex={-1}>
          <div className={classes.menuShareButtonContainer} tabIndex={-1}>
            <button
              aria-expanded={showMenu}
              aria-label="share options"
              type="button"
              className={`${classes.button} ${classes.menuShareButton} ${
                classes.menuContainer
              } ${className || ""}`}
              onClick={onOpenMenu}
            >
              <Share />
            </button>
          </div>
          <div
            className={`${classes.menu} ${
              showMenu ? classes.showMenu : classes.hideMenu
            }`}
          >
            <div className={classes.iconRow}>
              <div className={classes.iconCol} data-testid="chainlink">
                <button
                  aria-label="share link"
                  type="button"
                  className={`${classes.button} ${classes.menuButtonIcons}`}
                  onClick={onMenuItemLink}
                  tabIndex={0}
                >
                  <ChainLink />
                </button>
              </div>
              <div className={classes.iconCol} data-testid="facebook">
                <button
                  aria-label="share facebook"
                  type="button"
                  className={`${classes.button} ${classes.menuButtonIcons}`}
                  onClick={onMenuItemFacebook}
                  tabIndex={0}
                >
                  <Facebook />
                </button>
              </div>
            </div>
            <div className={classes.iconRow}>
              <div className={classes.iconCol} data-testid="twitter">
                <button
                  aria-label="share twitter"
                  type="button"
                  className={`${classes.button} ${classes.menuButtonIcons} ${classes.twitterXIcon}`}
                  onClick={onMenuItemTwitter}
                  tabIndex={0}
                >
                  <Twitter />
                </button>
              </div>
              <div className={classes.iconCol} data-testid="pinterest">
                <button
                  aria-label="share pinterest"
                  type="button"
                  className={`${classes.button} ${classes.menuButtonIcons}`}
                  onClick={onMenuItemPintInterest}
                  tabIndex={0}
                  onBlur={clickOutside}
                >
                  <Pintinterest />
                </button>
              </div>
            </div>
          </div>
        </div>
      </ClickOutsideListener>
      {tinyURL !== "" ? (
        <>
          <Toast
            text={
              tinyURL ? "Link copied to clipboard" : "Link couldn't be copied"
            }
            visible
            position="bottom"
            duration={2}
            id={id}
          />
        </>
      ) : null}
    </>
  );
};

ShareMenu.defaultProps = {
  url: undefined,
  className: undefined,
  svgColor: undefined,
  backgroundColor: undefined,
};
export default ShareMenu;
